import api from "@modules/api/api";
import { PromoCodeIsValidResponse } from "../types/PromoCodeIsValidResponse";

export default function getPromoCodeIsValid(promoCode: string) {
  return api.get<PromoCodeIsValidResponse>(
    `api/purchases/promo-code/${promoCode}/is-valid`
  );
}
